export default (value, rule) => value.toString().length >= rule.data;



// WEBPACK FOOTER //
// ./src/utils/validate/methods/minlength.js